import PropTypes from 'prop-types';

export const EventItemImageType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
});

export const UserTypeVk = 'vk';
export const UserTypeTelegram = 'telegram';

export const UserTypes = PropTypes.oneOf([UserTypeVk, UserTypeTelegram]);

export const CreatorType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  img: PropTypes.string,
  name: PropTypes.string.isRequired,
  payment_info: PropTypes.string,
  type: UserTypes.isRequired,
  vk_id: PropTypes.number,
  telegram_id: PropTypes.number,
  link: PropTypes.string,
});

export const MemberType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  img: PropTypes.string,
  name: PropTypes.string.isRequired,
  payment_info: PropTypes.string,
  amount: PropTypes.number.isRequired,
  type: UserTypes.isRequired,
  vk_id: PropTypes.number,
  telegram_id: PropTypes.number,
});

export const PaymentDistributionTypeValue = 'value';
export const PaymentDistributionTypeParts = 'parts';
export const PaymentDistributionTypeEqually = 'equally';

export const PaymentDistributionTypes = PropTypes.oneOf([PaymentDistributionTypeValue, PaymentDistributionTypeParts, PaymentDistributionTypeEqually]);

export const BorrowerType = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  user_id: PropTypes.number.isRequired,
});

export const CreditorType = PropTypes.shape({
  payments_count: PropTypes.number.isRequired,
  total_amount: PropTypes.number.isRequired,
  user_id: PropTypes.number.isRequired,
  users: PropTypes.arrayOf(BorrowerType).isRequired,
});

export const CreditorTypeV4 = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  creditor_id: PropTypes.number.isRequired,
  debtor_id: PropTypes.number.isRequired,
});
